import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-self":"stretch"} }
const _hoisted_2 = { class: "text-grey" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Unable to load Board list due to following error ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Not Found ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner_ios = _resolveComponent("q-spinner-ios")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_select, {
      ref: "qSelectRef",
      modelValue: _ctx.selected,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
        _ctx.inputFn
      ],
      class: "q-select-input",
      label: "Board Lookup",
      behavior: "dialog",
      "use-input": "",
      "options-dense": "",
      options: _ctx.options,
      "input-debounce": "250",
      onFilter: _ctx.filterFn,
      onPopupHide: _ctx.popupHideFn
    }, {
      option: _withCtx((scope) => [
        _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass([scope.opt.enabled ? 'text-indigo' : 'text-indigo-3'])
                    }, _toDisplayString(scope.opt.id) + ": ", 3 /* TEXT, CLASS */),
                    _createElementVNode("span", {
                      class: _normalizeClass([{ 'text-grey': !scope.opt.enabled }])
                    }, _toDisplayString(scope.opt.name), 3 /* TEXT, CLASS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */),
            _createVNode(_component_q_item_section, { side: "" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(scope.opt.type), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
      ]),
      "no-option": _withCtx(() => [
        (_ctx.hasError)
          ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, { text: "" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_q_item_label, {
                      caption: "",
                      class: "text-red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.error), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        (!_ctx.hasError)
          ? (_openBlock(), _createBlock(_component_q_item, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      append: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.options.length) + " ", 1 /* TEXT */),
        (!_ctx.hasError && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: "mdi-filter"
            }))
          : _createCommentVNode("v-if", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_q_spinner_ios, {
              key: 1,
              class: "on-right"
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "options", "onFilter", "onUpdate:modelValue", "onPopupHide"]),
    _createVNode(_component_q_btn, {
      icon: "mdi-menu-down",
      class: "q-px-xs",
      flat: "",
      stretch: "",
      onClick: _ctx.showPopupFn
    }, null, 8 /* PROPS */, ["onClick"])
  ]))
}